import { Component } from '@angular/core';

@Component({
    selector: 'admin-users',
    templateUrl: './users.component.html'
})
/**
 * Component to display the user management.
 */
export class UsersComponent {
}



// WEBPACK FOOTER //
// ./src/app/admin/users/users.component.ts